import React, {useEffect, useState} from 'react';
import Spinner from "../Spinner";
import logger from '../../utils/logger';

const Viewer = ({id, onFloor, modelUrl = ''}) => {
    logger.info('onFloor = ', onFloor)
    const parentId = `3d-model-${id}`;
    const [isLoaded, setIsLoaded] = useState(false);


    return (
        <div className={"model-container"} id={parentId}>
            {!isLoaded && <Spinner />}
        </div>
    )
}

export default Viewer;
